import type { SxProps, Theme } from '@mui/material/styles';

// Width of the header and page cards. MUI v4's down() chain (down('xl') matched every width)
// translated to mobile-first values: 16px gutters below 768px, 32px below 1200px.
export const containerWidth = {
    xs: 'calc(100% - 16px)',
    md: 'calc(100% - 32px)',
    xl: '1100px',
};

export const styles = {
    layout: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'secondary.main',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto',
        color: 'text.primary',
        fontFamily: '"Roboto", sans-serif',
        pt: 5,
        pb: 5,
        boxSizing: 'border-box',
        width: '100%',
    },
    page: {
        position: 'relative',
        width: containerWidth,
        backgroundColor: 'background.paper',
        mt: -2,
        pt: 2,
    },
} satisfies Record<string, SxProps<Theme>>;
